import styled from "styled-components";

export const ButtonContainer = styled.button`
	display: flex;
	gap: 5px;
	align-items: center;
	justify-content: center;
	min-width: fit-content;
	&:hover {
		opacity: 0.9;
	}
	&:disabled,
	&[disabled] {
		opacity: 0.4;
	}
`;
